import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { baseURL } from "../Constant";
export const ReminderSlice = createSlice({
 name: "reminder",
 initialState: {
  error: false,

  reminderMail: "",
  isReminderLoaded: false,
 },
 reducers: {
  setReminderMail: (state, { payload }) => {
   state.reminderMail = payload;
   state.isReminderLoaded = true;
  },

  setError: (state) => {
   state.error = true;
  },

  setReminderLoad: (state) => {
   state.isReminderLoaded = false;
  },
 },
});

// Action creators are generated for each case reducer function
export const { setError, setReminderMail, setReminderLoad } = ReminderSlice.actions;

export default ReminderSlice.reducer;

export function handleGenerateReminder(values) {
 return (dispatch) => {
  console.log("in here dispacth");

  axios
   .post(`${baseURL}/reminder/fetchResponse`, { values })
   .then((response) => {
    // then print response status
    dispatch(setReminderMail(response.data));
   })
   .catch((err) => {
    // then print response status
    // console.error("fetch fail", err);
   });
 };
}
export function handleReminderLoading() {
 return (dispatch) => {
  dispatch(setReminderLoad());
 };
}
